import { Box, Skeleton } from '@bonanza-social/moonlight';
import { memo } from 'react';

function InviteFriendsSkeleton() {
  return (
    <Box paddingTop="space-400" gap="space-400">
      <Skeleton width="100%" aspectRatio={16 / 9} />
      <Box flexDirection="row" gap="space-400">
        <Skeleton flex={1} height={45} />
        <Skeleton flex={1} height={45} />
      </Box>
      <Box gap="space-200">
        <Skeleton height={26} />
        <Skeleton height={26} />
      </Box>
    </Box>
  );
}

export default memo(InviteFriendsSkeleton);
